import i18next from 'i18next';

i18next.addResources('es', 'ErrorScreen', {
  message: 'Ha ocurrido un error',
  button: 'Volver a cargar'
});
